/**
 * Enum for query parameter keys used throughout the application
 * This centralizes all query parameter definitions to ensure consistency
 */
export enum QueryParams {
  OPEN_FILE = 'isOpen',
  ADD_NEW = 'isNew',
  BIZ_ENTITY_ID = 'id',
  PARENT_ID = 'parentId',
  TYPE_ID = 'typeId',
  ID = 'id',
  ITEM = 'item',
  SELECTED_ITEM = 'selectedItem',
  IS_TEMPLATE = 'isTemplate',
  CATEGORY = 'category',
  TYPE = 'type'
}

/**
 * Enum for query parameter values used throughout the application
 */
export enum QueryParamValues {
  TRUE = 'true',
  DEFAULT_PARENT_ID = '39734'
}

/**
 * Enum for string representations of boolean values
 * Use when working with string-based boolean comparisons (localStorage, query params, etc.)
 */
export enum BooleanString {
  TRUE = 'true',
  FALSE = 'false'
}

/**
 * Enum for sessionStorage keys used throughout the application
 */
export enum SessionStorageKeys {
  DASHBOARD_NAVIGATION_SOURCE = 'dashboardNavigationSource',
  DASHBOARD_SELECTED_ITEM = 'dashboardSelectedItem'
}

/**
 * Enum for sessionStorage values used throughout the application
 */
export enum SessionStorageValues {
  DASHBOARD = 'dashboard'
}
